<script setup>
import Grid from "../../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import AiSequenceEdit from "@/components/aiSequences/AiSequenceEdit.vue";
import aiSequencesService from "@/services/ai-sequences.service";

const {items, gridParams, gridMethods} = useGrid(aiSequencesService.getList);

const columns = [
    {
        label: 'Name',
        name: 'name',
    },
    {
        label: 'Description',
        name: 'description',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const editSequenceModal = ref(null);

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function gridAction(params) {
    if (params.action === 'edit') {
        editSequenceModal.value.open(params.rowId);
    }
}
</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    v-on:changePage="gridMethods.changePage"
                    v-on:action="gridAction"
                />
            </div>
        </div>

        <AiSequenceEdit
            ref="editSequenceModal"
            @saved="gridMethods.updateList"
        />
    </div>
</template>

<style scoped>

</style>
